/* unplugin-vue-components disabled */import { render } from "./integrations.vue?vue&type=template&id=26a6ae37&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"

import "./integrations.vue?vue&type=style&index=0&id=26a6ae37&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a6ae37"],['__file',"src/pages/settings/integrations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26a6ae37"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26a6ae37', __exports__)) {
    api.reload('26a6ae37', __exports__)
  }
  
  module.hot.accept("./integrations.vue?vue&type=template&id=26a6ae37&scoped=true", () => {
    api.rerender('26a6ae37', render)
  })

}


export default __exports__